import type {SidebarLink} from '@github-ui/saved-views'

export const repoSidebarLinks: SidebarLink[] = [
  {
    id: 'issues',
    name: 'Issues',
    searchType: 'issues',
    query: 'state:open archived:false sort:updated-desc',
    icon: 'issue_opened',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'assigned-to-you',
    name: 'Assigned to you',
    searchType: 'issues',
    query: 'state:open archived:false assignee:@me sort:updated-desc',
    icon: 'people',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'created-by-you',
    name: 'Created by you',
    searchType: 'issues',
    query: 'state:open archived:false author:@me sort:updated-desc',
    icon: 'person',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'mentioning-you',
    name: 'Mentioning you',
    searchType: 'issues',
    query: 'state:open archived:false mentions:@me sort:updated-desc',
    icon: 'mention',
    color: 'gray',
    source: 'predefined',
  },
]
